<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<!-- 서브메뉴 탭 구성 //-->
<ng-container *ngIf="(currMenu$ | async)['page_cd'].length > 6 && (currMenu$ | async)['parentNode']['children'].length > 0">
  <ul class="sub-tab inner-wrap">
    <li class="nav-item" *ngFor="let item of (currMenu$ | async)['parentNode']['children']; index as i">
      <a class="cp nav-link" [ngClass]="{active: (currMenu$ | async)['seq'] == item.seq}"  (click)="goLink(item)">{{item.page_menu_name}}</a>
    </li>
  </ul>
</ng-container>

<div class="board-view inner-wrap">
 <div class="cb"></div>

  <table>
  <colgroup>
    <col class="col1">
    <col class="col2">
  </colgroup>

  <tbody>
  <tr class="title">
    <td colspan="2">
      <ng-container *ngIf="data['detail'] != undefined">
      {{data['detail'].subject}}
      </ng-container>
    </td>
  </tr>

  <tr class="info">
    <td colspan="2">
      <div *ngIf="data['detail'] != undefined">{{data['detail'].write_date}}</div>
      <div *ngIf="data['detail'] != undefined">Hits {{data['detail'].hit}}</div>
    </td>
  </tr>

  <tr class="contents">
    <td colspan="2">
      <ng-container *ngIf="data['detail'] != undefined" >
      <div [innerHTML]="data['detail'].contents | safe: 'html'"></div>
      </ng-container>
    </td>
  </tr>
  <ng-container *ngIf="data['detail'] != undefined">
  <tr class="append-file" *ngIf="data['upload'].length > 0">
    <th>File</th>
    <td>
      <ul>
        <ng-container *ngFor="let item of data['upload']">
        <li *ngIf="( boardInfo.upload_image_down == false && item.file_type !== 'IMAGE' ) || boardInfo.upload_image_down == true">
          <a href="{{item.url}}" target="_blank">{{item.origin}}</a>
        </li>
        </ng-container>
      </ul>
    </td>
  </tr>
  </ng-container>
  </tbody>
  </table>

  <div>
    <button class="list-btn" (click)="list()">List</button>
  </div>
</div>

